import AclName from '../AclName.js';

const excluded = [
  AclName.AmqpQueuesList,
  AclName.CrmBtnAgreementFileSend,
  AclName.CrmFormCrmSaveDeletedItem,
  AclName.CrmPageSubscriptionPanel,
  AclName.DemoMessageStart,
  AclName.SettingsPageSubscriptionPanel,
  AclName.StaffAccessAll,
  AclName.SettingsPageSystemTaskList,
  AclName.SettingsPageSystemTaskEdit,
  AclName.CrmSectionSystemBalancePrepaid,
  AclName.EmployeeAddEditCompanyDataTabAccess,
  AclName.ProfileEditCompanyDataTabAccess,

  // Edycja profilu
  AclName.ProfileViewCompanyDataIndustryTypesAccess,

  // Developer settings
  AclName.UserInfoDialogAccess,
];

export default Object.values(AclName).filter((acl) => !excluded.includes(acl));
